document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("custom-popup");
  if (!popup) return;

  const delay = parseInt(popup.dataset.delay);
  const frequency = popup.dataset.frequency;
  const closeBtn = popup.querySelector(".popup-close");

  const today = new Date().toDateString();
  const shown = localStorage.getItem("popupShown");
  const shownDate = localStorage.getItem("popupShownDate");

  let showPopup = false;

  if (frequency === "always") showPopup = true;
  if (frequency === "once" && !shown) showPopup = true;
  if (frequency === "daily" && shownDate !== today) showPopup = true;

  if (showPopup) {
    setTimeout(() => {
      popup.style.display = "flex";
      localStorage.setItem("popupShown", "true");
      localStorage.setItem("popupShownDate", today);
    }, delay);
  }

  closeBtn.addEventListener("click", function () {
    popup.style.display = "none";
  });

  // Auto-close after successful submission
  if (popup.querySelector(".popup-success")) {
    setTimeout(() => {
      popup.style.display = "none";
    }, 2000);
  }
});
